import _styled from '@emotion/styled/base';
import { _ as __makeTemplateObject, e as __rest, a as _assign, B as BodyPortal, Z as ZINDEX, O as OverlayProvider } from './common.js';
export { I as IntersectionObserver, g as OverlayContext, h as OverlayPortal, P as Portal, o as onCheckHandler, i as onEnterHandler, j as onValueHandler } from './common.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { forwardRef, useRef, useState, useEffect, cloneElement, useReducer, useCallback, useMemo, createContext, useContext } from 'react';
import { R as ResizeImage, m as makeIndicatorDots, L as Loading } from './Loading.js';
export { D as DEFAULT_RESIZE_IMAGE } from './Loading.js';
import { useTheme, ClassNames, css, keyframes, createElement, ThemeProvider } from '@emotion/react';
import classNames from 'classnames';
import { formatComma } from '@bucketplace/lib';
import { p as pxToRem, F as FONT_STYLE, M as MEDIA_QUERY, P as PALETTE, R as RESET_BUTTON, s as safeAreaInset, a as RESET_INPUT, D as DARK_THEME, L as LIGHT_THEME } from './foundation.js';
export { B as BREAK_POINT, b as BREAK_POINT_NAMES, i as DEPRECATED_KEYS, g as FOCUS, d as GLOBAL_IMPORT_FONT, G as GLOBAL_IMPORT_ICON, f as GLOBAL_STYLE, e as GLOBAL_STYLE_FONT, c as GLOBAL_STYLE_ICON, H as HOVER, O as ODS_FONT_STYLE, S as SHADOW_STYLE, h as hexToRgba, r as rgba } from './foundation.js';
import isPropValid from '@emotion/is-prop-valid';
import { I as InfoIcon, A as AlertFilledIcon } from './icons.js';
export { c as AddCircleFilledIcon, b as AddCircleIcon, a as AddIcon, d as AlertIcon, e as ArrowClockwiseIcon, f as ArrowDownIcon, i as ArrowLeftArrowRightIcon, g as ArrowLeftIcon, h as ArrowRightIcon, j as ArrowUpIcon, k as AttachIcon, B as BullhornIcon, C as CalculatorIcon, l as CalendarIcon, n as CallFilledIcon, m as CallIcon, p as CameraFilledIcon, o as CameraIcon, r as CardFilledIcon, q as CardIcon, s as CartIcon, u as CashFilledIcon, t as CashIcon, v as CheckIcon, w as ChevronDownIcon, x as ChevronLeftIcon, y as ChevronRightIcon, z as ChevronUpIcon, D as CircleCheckFilledIcon, E as CircleFilledIcon, F as CircleWonFilledIcon, H as ClockFilledIcon, G as ClockIcon, K as CommentFilledIcon, J as CommentIcon, L as ContentListIcon, N as CouponFilledIcon, M as CouponIcon, O as CrownFilledIcon, Q as DataListFilledIcon, P as DataListIcon, S as DeleteFilledIcon, R as DeleteIcon, U as DismissCircleIcon, T as DismissIcon, V as DownloadIcon, W as DropdownDownIcon, X as DropdownRightIcon, Y as DropdownUpIcon, Z as ExpandIcon, _ as ExportIcon, $ as FastForwardFilledIcon, a1 as FilterFilledIcon, a0 as FilterIcon, a2 as FilterNewIcon, b8 as HandlerIcon, a4 as HeartFilledIcon, a3 as HeartIcon, a6 as HomeFilledIcon, a5 as HomeIcon, a7 as InfoFilledIcon, a8 as LaunchIcon, a9 as LinkIcon, ab as LocationFilledIcon, aa as LocationIcon, ad as LockFilledIcon, ac as LockIcon, af as MedalFilledIcon, ae as MedalIcon, ah as MenuFoldIcon, ag as MenuIcon, ai as MenuOpenIcon, aj as MoreHorizontalIcon, ak as MoreVerticalIcon, am as NotificationFilledIcon, al as NotificationIcon, an as PhotoIcon, ao as PlayCircleIcon, ap as PlayFilledIcon, ar as PointFilledIcon, aq as PointIcon, at as PresentFilledIcon, as as PresentIcon, av as QuestionFilledIcon, au as QuestionIcon, ax as ScrapFilledIcon, aw as ScrapIcon, ay as SearchIcon, az as SearchImageIcon, aA as SendFilledIcon, aB as SettingIcon, aC as ShareIcon, aE as ShieldFilledIcon, aD as ShieldIcon, aH as SignOutIcon, aG as SignedFilledIcon, aF as SignedIcon, aI as SortingIcon, aJ as SoundMuteFilledIcon, aK as SoundOffFilledIcon, aL as SoundOnFilledIcon, aM as SquareAndPencilIcon, aO as StackedImagesFilledIcon, aN as StackedImagesIcon, aQ as StarFilledIcon, aP as StarIcon, aR as StatIcon, aT as StoreFilledIcon, aS as StoreIcon, aU as SubtractIcon, aV as TagFilledIcon, a_ as TagIcon, aW as TextBoldIcon, aX as TextItalicIcon, aY as TextUnderlineIcon, aZ as ThumbsUpIcon, b0 as TruckFilledIcon, a$ as TruckIcon, b1 as UndoIcon, b2 as UploadIcon, b3 as ViewListFilledIcon, b4 as ViewThumbnailFilledIcon, b5 as WonIcon, b7 as WriteFilledIcon, b6 as WriteIcon } from './icons.js';
import { StickyProvider } from '@bucketplace/ui';
export { c as createCachedFetch, d as decomposeHangul, u as useAutoComplete, a as useChanged, b as useForkRef, f as useIEDetector, e as useIsInApp, l as useKakaoChat, g as useMatchMedia, h as useMedia, i as useNodeSizeObserver, j as useResize, m as useResponsive, k as useWindowsOSDetector } from './hooks.js';
export { A as APP_BANNER_PATHNAME_BLACKLIST, e as APP_BANNER_SEARCH_BLACKLIST, d as calcImageSize, g as getDeviceInfo, b as getImageSrcSet, a as getImageUrl, c as getNearestSize, i as isHigherAppVersion } from './utils.js';
import 'react-intersection-observer';
import 'react-dom';
import 'qs';
import 'lodash';

var placeholderIconSize = {
  18: 12,
  24: 16,
  30: 18,
  40: 24,
  80: 48
};
var Avatar = /*#__PURE__*/forwardRef(function (_a, ref) {
  var size = _a.size,
    PlaceholderIcon = _a.placeholderIcon,
    src = _a.src,
    className = _a.className,
    rest = __rest(_a, ["size", "placeholderIcon", "src", "className"]);
  return jsx(Container$6, _assign({
    ref: ref
  }, rest, {
    className: className,
    size: size
  }, {
    children: src ? jsx(ResizeImage, {
      src: src,
      alt: "\uC544\uBC14\uD0C0 \uC0AC\uC9C4",
      style: {
        width: '100%',
        height: '100%',
        borderRadius: '50%'
      },
      "aria-label": "avatar"
    }) : jsx(PlaceholderIcon, {
      size: placeholderIconSize[size],
      fill: function fill(theme) {
        return theme.base.neutral500;
      },
      "aria-label": "avatar-placeholder"
    })
  }));
});
var Container$6 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "egjvr3j0"
} : {
  target: "egjvr3j0",
  label: "Container"
})(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  border-radius: 50%;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: ", "px;\n  height: ", "px;\n  border-radius: 50%;\n  background-color: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (_a) {
  var size = _a.size;
  return size;
}, function (_a) {
  var size = _a.size;
  return size;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral300;
});
var templateObject_1$g;

/**
 * children에 hover interaction을 적용합니다.
 * children component에 className props가 필요합니다.
 * 타겟이 되는 컴포넌트의 position을 relative로 설정하고, hover interaction을 적용합니다.
 * 만약 relative가 아닌 다른 position을 사용하고 싶다면, HoverInteraction을 한번더 Wrapper로 감싸서 적용해주세요.
 * @param children
 * @param disabled
 * @constructor
 */
var HoverInteraction = function HoverInteraction(_a) {
  var _children = _a.children,
    disabled = _a.disabled;
  var theme = useTheme();
  var childRef = useRef(null);
  var _b = useState(0),
    borderWidth = _b[0],
    setBorderWidth = _b[1];
  useEffect(function () {
    if (childRef.current && typeof window !== 'undefined') {
      var computedStyle = window.getComputedStyle(childRef.current);
      var border = computedStyle.getPropertyValue('border-width');
      setBorderWidth(parseFloat(border));
    }
  }, []);
  return jsx(ClassNames, {
    children: function children(_a) {
      var css = _a.css;
      return /*#__PURE__*/cloneElement(_children, {
        ref: childRef,
        className: classNames(!disabled && css(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n              position: relative;\n              @media (hover: hover) or (pointer: fine) {\n                cursor: pointer;\n                &::after {\n                  content: '';\n                  position: absolute;\n                  left: -", ";\n                  top: -", ";\n                  right: -", ";\n                  bottom: -", ";\n                  transition: background-color 0.1s ease-in-out;\n                  border-radius: inherit;\n                  background-color: initial;\n                }\n                &:hover::after {\n                  // TODO \uCEEC\uB7EC ODS \uC801\uC6A9\n                  background-color: ", ";\n                }\n              }\n            "], ["\n              position: relative;\n              @media (hover: hover) or (pointer: fine) {\n                cursor: pointer;\n                &::after {\n                  content: '';\n                  position: absolute;\n                  left: -", ";\n                  top: -", ";\n                  right: -", ";\n                  bottom: -", ";\n                  transition: background-color 0.1s ease-in-out;\n                  border-radius: inherit;\n                  background-color: initial;\n                }\n                &:hover::after {\n                  // TODO \uCEEC\uB7EC ODS \uC801\uC6A9\n                  background-color: ", ";\n                }\n              }\n            "])), pxToRem(borderWidth), pxToRem(borderWidth), pxToRem(borderWidth), pxToRem(borderWidth), theme.dim.thin), _children.props.className)
      });
    }
  });
};
var templateObject_1$f;

var getColorTokenProps = function getColorTokenProps(variant, theme) {
  var colorTokens = {
    primary_thin: {
      backgroundColor: theme.primary.lighten,
      textColor: theme.primary.darken,
      borderColor: theme.primary.darken,
      numberColor: theme.primary.darken
    },
    white: {
      backgroundColor: theme.base.neutral0,
      textColor: theme.base.neutral700,
      borderColor: theme.border,
      numberColor: theme.primary.darken
    },
    base5: {
      backgroundColor: theme.base.neutral100,
      textColor: theme.base.neutral700,
      borderColor: theme.base.neutral100,
      numberColor: theme.primary.darken
    },
    base1: {
      backgroundColor: theme.base.neutral600,
      textColor: theme.base.neutral0,
      borderColor: theme.base.neutral600,
      numberColor: theme.primary.darken
    }
  };
  return colorTokens[variant];
};
var Chip = /*#__PURE__*/forwardRef(function (_a, ref) {
  var text = _a.text,
    number = _a.number,
    variant = _a.variant,
    leftIcon = _a.leftIcon,
    rightIcon = _a.rightIcon,
    className = _a.className,
    restProps = __rest(_a, ["text", "number", "variant", "leftIcon", "rightIcon", "className"]);
  var theme = useTheme();
  return jsx(HoverInteraction, {
    children: jsxs(Container$5, _assign({
      ref: ref
    }, restProps, getColorTokenProps(variant, theme), {
      className: classNames(className, {
        clickable: !!restProps.onClick
      })
    }, {
      children: [leftIcon && /*#__PURE__*/cloneElement(leftIcon, {
        size: 12,
        className: 'left-icon'
      }), text, typeof number === 'number' && jsx("span", _assign({
        className: "chip-number"
      }, {
        children: formatComma(number)
      })), rightIcon && /*#__PURE__*/cloneElement(rightIcon, {
        size: 12,
        className: 'right-icon'
      })]
    }))
  });
});
var Container$5 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1grob030"
} : {
  target: "e1grob030",
  label: "Container"
})(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n  ", ";\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 50px;\n  box-sizing: border-box;\n  height: 38px;\n  padding: 10px 14px;\n  ", "\n  \n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border: 1px solid ", ";\n    border-radius: inherit;\n  }\n  \n  &.clickable {\n    cursor: pointer;\n  }\n  \n  .chip-number {\n    color: ", ";\n    margin-left: 2px;\n  }\n  \n  .left-icon {\n    margin-right: 4px;\n  }\n  \n  .right-icon {\n    margin-left: 4px\n  }\n"], ["\n  ", ";\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 50px;\n  box-sizing: border-box;\n  height: 38px;\n  padding: 10px 14px;\n  ", "\n  \n  &::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    border: 1px solid ", ";\n    border-radius: inherit;\n  }\n  \n  &.clickable {\n    cursor: pointer;\n  }\n  \n  .chip-number {\n    color: ", ";\n    margin-left: 2px;\n  }\n  \n  .left-icon {\n    margin-right: 4px;\n  }\n  \n  .right-icon {\n    margin-left: 4px\n  }\n"])), FONT_STYLE.body14L18, function (_a) {
  var backgroundColor = _a.backgroundColor;
  return backgroundColor;
}, function (_a) {
  var textColor = _a.textColor;
  return textColor;
}, MEDIA_QUERY.max('mobile', /*#__PURE__*/css(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n    border-radius: 100px;\n    height: 32px;\n    padding: 7px 12px;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Container;")], ["\n    border-radius: 100px;\n    height: 32px;\n    padding: 7px 12px;\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Container;")])))), function (_a) {
  var borderColor = _a.borderColor;
  return borderColor;
}, function (_a) {
  var numberColor = _a.numberColor;
  return numberColor;
});
var templateObject_1$e, templateObject_2$a;

var BadgeBaseContainer = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e6n7lej1"
} : {
  target: "e6n7lej1",
  label: "BadgeBaseContainer"
})(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  background: ", ";\n  color: ", ";\n  font-weight: 700;\n  letter-spacing: -0.3px;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n"], ["\n  background: ", ";\n  color: ", ";\n  font-weight: 700;\n  letter-spacing: -0.3px;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.accent.basic;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral0;
});
var CircleBadgeContainer = /*#__PURE__*/_styled(BadgeBaseContainer, process.env.NODE_ENV === "production" ? {
  target: "e6n7lej0"
} : {
  target: "e6n7lej0",
  label: "CircleBadgeContainer"
})(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  border-radius: 47px;\n  flex-direction: column;\n\n  ", "\n"], ["\n  border-radius: 47px;\n  flex-direction: column;\n\n  ", "\n"])), function (_a) {
  var size = _a.size;
  switch (size) {
    case 16:
      {
        return /*#__PURE__*/css(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n          ", "\n          height: 16px;\n          padding: 0px 6px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:CircleBadgeContainer;")], ["\n          ", "\n          height: 16px;\n          padding: 0px 6px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:CircleBadgeContainer;")])), FONT_STYLE.detail10L14);
      }
    case 20:
      {
        return /*#__PURE__*/css(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n          ", ";\n          height: 20px;\n          padding: 0px 7px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:CircleBadgeContainer;")], ["\n          ", ";\n          height: 20px;\n          padding: 0px 7px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:CircleBadgeContainer;")])), FONT_STYLE.detail12L16);
      }
  }
});
var templateObject_1$d, templateObject_2$9, templateObject_3$6, templateObject_4$5;

var MAX_VALUE = 99;
var CircleBadge = /*#__PURE__*/forwardRef(function (props, ref) {
  var size = props.size,
    value = props.value,
    rest = __rest(props, ["size", "value"]);
  return jsx(CircleBadgeContainer, _assign({
    ref: ref
  }, rest, {
    size: size
  }, {
    children: value > MAX_VALUE ? "".concat(MAX_VALUE, "+") : value
  }));
});

var SquareBadge = function SquareBadge(props) {
  var size = props.size,
    variant = props.variant,
    children = props.children,
    leftIcon = props.leftIcon,
    rightIcon = props.rightIcon,
    className = props.className,
    rest = __rest(props, ["size", "variant", "children", "leftIcon", "rightIcon", "className"]);
  var iconSize = size === 24 ? 16 : 12;
  return jsxs(SquareBadgeContainer, _assign({}, rest, {
    size: size,
    className: classNames(className, variant)
  }, {
    children: [leftIcon && /*#__PURE__*/cloneElement(leftIcon, {
      size: iconSize,
      className: 'left-icon'
    }), children, rightIcon && /*#__PURE__*/cloneElement(rightIcon, {
      size: iconSize,
      className: 'right-icon'
    })]
  }));
};
var FontStyleBySize = {
  16: /*#__PURE__*/css(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n    ", "\n    height: 16px;\n    padding: 0px 4px;" + (process.env.NODE_ENV === "production" ? "" : ";label:FontStyleBySize;")], ["\n    ", "\n    height: 16px;\n    padding: 0px 4px;" + (process.env.NODE_ENV === "production" ? "" : ";label:FontStyleBySize;")])), FONT_STYLE.detail10L14),
  20: /*#__PURE__*/css(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n    ", ";\n    height: 20px;\n    padding: 0px 6px;" + (process.env.NODE_ENV === "production" ? "" : ";label:FontStyleBySize;")], ["\n    ", ";\n    height: 20px;\n    padding: 0px 6px;" + (process.env.NODE_ENV === "production" ? "" : ";label:FontStyleBySize;")])), FONT_STYLE.detail12L16),
  24: /*#__PURE__*/css(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n    ", ";\n    height: 24px;\n    padding: 0px 6px;" + (process.env.NODE_ENV === "production" ? "" : ";label:FontStyleBySize;")], ["\n    ", ";\n    height: 24px;\n    padding: 0px 6px;" + (process.env.NODE_ENV === "production" ? "" : ";label:FontStyleBySize;")])), FONT_STYLE.detail12L16)
};
var SquareBadgeContainer = /*#__PURE__*/_styled(BadgeBaseContainer, process.env.NODE_ENV === "production" ? {
  target: "e15u479s0"
} : {
  target: "e15u479s0",
  label: "SquareBadgeContainer"
})(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  border-radius: 4px;\n  flex-direction: row;\n  gap: 4px;\n  flex-shrink: 0;\n\n  &.primary {\n    background: ", ";\n  }\n\n  &.accent {\n    background: ", ";\n  }\n\n  &.dim_dark {\n    background: ", ";\n  }\n\n  &.neutral300 {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.neutral500 {\n    background: ", ";\n  }\n\n  ", "\n"], ["\n  border-radius: 4px;\n  flex-direction: row;\n  gap: 4px;\n  flex-shrink: 0;\n\n  &.primary {\n    background: ", ";\n  }\n\n  &.accent {\n    background: ", ";\n  }\n\n  &.dim_dark {\n    background: ", ";\n  }\n\n  &.neutral300 {\n    background: ", ";\n    color: ", ";\n  }\n\n  &.neutral500 {\n    background: ", ";\n  }\n\n  ", "\n"])), function (_a) {
  var theme = _a.theme;
  return theme.primary.basic;
}, function (_a) {
  var theme = _a.theme;
  return theme.accent.basic;
}, function (_a) {
  var theme = _a.theme;
  return theme.interactive.dim.thick;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral300;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral500;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral500;
}, function (_a) {
  var size = _a.size;
  return FontStyleBySize[size];
});
var templateObject_1$c, templateObject_2$8, templateObject_3$5, templateObject_4$4;

var PillBadge = /*#__PURE__*/forwardRef(function (props, ref) {
  var size = props.size,
    value = props.value,
    rest = __rest(props, ["size", "value"]);
  return jsx(CircleBadgeContainer, _assign({
    ref: ref
  }, rest, {
    size: size
  }, {
    children: value
  }));
});

var DotBadge = /*#__PURE__*/forwardRef(function (props, ref) {
  var rest = __rest(props, []);
  return jsx(Container$4, _assign({
    ref: ref
  }, rest, {
    "data-testid": "dot-badge"
  }));
});
var Container$4 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e78z9x80"
} : {
  target: "e78z9x80",
  label: "Container"
})(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  display: inline-block;\n  background-color: ", ";\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n"], ["\n  display: inline-block;\n  background-color: ", ";\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.accent.basic;
});
var templateObject_1$b;

/**
 * Divider
 * @see {@link https://www.figma.com/design/aTdWM1sgdScr68GZdQ2sWO/ODS-(Ohouse-Design-System)-Master?node-id=21462-14943&t=DjaawziSis6vCaS1-0}
 */
var Divider = /*#__PURE__*/forwardRef(function (props, ref) {
  return jsx(DividerContainer, _assign({
    ref: ref
  }, props));
});
var DividerContainer = /*#__PURE__*/_styled("hr", process.env.NODE_ENV === "production" ? {
  target: "e15zb1dk0"
} : {
  target: "e15zb1dk0",
  label: "DividerContainer"
})(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  height: ", "px;\n  border: none;\n  background-color: ", ";\n"], ["\n  margin: 0;\n  padding: 0;\n  height: ", "px;\n  border: none;\n  background-color: ", ";\n"])), function (_a) {
  var height = _a.height;
  return height;
}, function (_a) {
  var theme = _a.theme,
    height = _a.height;
  return height === 1 ? theme.base.neutral300 : theme.base.neutral100;
});
var templateObject_1$a;

function dotSize(index, maxPage, activeIndex) {
  if (maxPage <= 4) {
    return index === activeIndex ? 8 : 6;
  }
  // activeIndex의 왼쪽.
  if (index <= activeIndex) {
    var delta = activeIndex - index;
    if (activeIndex === maxPage - 1) {
      if (delta <= 2) {
        return 8;
      } else if (delta === 3) {
        return 6;
      } else if (delta === 4) {
        return 4;
      }
      return 0;
    } else {
      if (delta <= 2) {
        return 8;
      } else if (delta === 3) {
        return 6;
      }
      return 0;
    }
  }
  // activeIndex의 오른쪽.
  if (activeIndex <= 2) {
    if (index <= 2) {
      return 8;
    } else if (index === 3) {
      return 6;
    } else if (index === 4) {
      return 4;
    }
    return 0;
  } else {
    return index - activeIndex === 1 ? 6 : 0;
  }
}
function IndicatorDots(props) {
  var theme = useTheme();
  return makeIndicatorDots({
    dotSize: dotSize,
    dotBackgroundColor: theme.dim.onDark.thick,
    activeDotBackgroundColor: PALETTE.white,
    boxShadow: "".concat(pxToRem(0), " ").concat(pxToRem(2), " ").concat(pxToRem(5), " ").concat(theme.shadow.basic)
  })(props);
}

/**
 * 스낵바 메시지 위치 옵션
 * - basic : 바텀 하단에 스낵바 메시지 노출
 * - fab : FAB 가 보이도록 메시지 노출
 */
var SNACKBAR_PLACEMENT = {
  basic: 'basic',
  fab: 'fab'
};

function snackBarReducer(state, action) {
  switch (action.type) {
    case 'open':
      {
        var newItem = {
          id: state.id,
          state: 'open',
          options: action.options
        };
        state.items.forEach(function (item) {
          var _a, _b;
          (_b = (_a = item.options).onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
        var items = [newItem];
        return _assign(_assign({}, state), {
          id: state.id + 1,
          items: items,
          placement: getPlacement(items)
        });
      }
    case 'close':
      {
        var items = state.items.map(function (v) {
          if (v.id === action.id) {
            return _assign(_assign({}, v), {
              state: 'closing'
            });
          }
          return v;
        });
        return _assign(_assign({}, state), {
          items: items,
          placement: getPlacement(items)
        });
      }
    case 'closeAll':
      {
        return _assign(_assign({}, state), {
          items: state.items.map(function (v) {
            return _assign(_assign({}, v), {
              state: 'closing'
            });
          })
        });
      }
    case 'closed':
      {
        var entry = state.items.find(function (v) {
          return v.id === action.id;
        });
        if (entry != null && entry.options.onClose != null) {
          entry.options.onClose();
        }
        var items = state.items.filter(function (v) {
          return v.id !== action.id;
        });
        return _assign(_assign({}, state), {
          isEngaged: state.items.length > 1 ? state.isEngaged : false,
          items: items,
          placement: getPlacement(items)
        });
      }
    case 'engage':
      return _assign(_assign({}, state), {
        isEngaged: true
      });
    case 'disengage':
      return _assign(_assign({}, state), {
        isEngaged: false
      });
    case 'shift':
      {
        var closeItem = state.items.find(function (v) {
          return v.state === 'open';
        });
        if (closeItem == null) return state;
        return snackBarReducer(state, {
          type: 'close',
          id: closeItem.id
        });
      }
    default:
      return state;
  }
}
/**
 * 스낵바 상태를 관리하는 훅입니다.
 * 스낵바는 queue 형태로 관리하고 있으나, queue내에 한번에 존재할 수 있는 스낵바는 1개로 제한됩니다.
 * 기존 스낵바가 shift 된기 전에 새로운 스낵바가 들어오면 기존 스낵바는 곧바로 shift되어 별도의 closing 상태(fadeout 애니메이션)를 거치지 않고 제거됩니다.
 * 또한, 유저가 스낵바와 인터렉션 중인 상태일 때에는 (engaged) 스낵바가 closing 상태로 변경되지 않도록 isEngaged 상태를 관리합니다.
 * @returns SnackbarStateResult
 */
function useSnackbarState() {
  var _a = useReducer(snackBarReducer, {
      id: 0,
      isEngaged: false,
      items: [],
      placement: SNACKBAR_PLACEMENT.basic
    }),
    state = _a[0],
    dispatch = _a[1];
  var handleEngage = useCallback(function () {
    dispatch({
      type: 'engage'
    });
  }, [dispatch]);
  var handleDisengage = useCallback(function () {
    dispatch({
      type: 'disengage'
    });
  }, [dispatch]);
  var handleOpen = useCallback(function (options) {
    dispatch({
      type: 'open',
      options: options
    });
  }, [dispatch]);
  var handleClose = useCallback(function (id) {
    dispatch({
      type: 'close',
      id: id
    });
  }, [dispatch]);
  var handleClosed = useCallback(function (id) {
    dispatch({
      type: 'closed',
      id: id
    });
  }, [dispatch]);
  var handleCloseAll = useCallback(function () {
    dispatch({
      type: 'closeAll'
    });
  }, [dispatch]);
  useEffect(function () {
    if (state.isEngaged || state.items.length === 0) return;
    var closeItem = state.items.find(function (v) {
      return v.state === 'open';
    });
    if (closeItem != null) {
      // If it's not engaged, try to remove items every few seconds
      var duration = closeItem.options.duration || 3000;
      var timer_1 = setTimeout(function () {
        return dispatch({
          type: 'shift'
        });
      }, duration);
      return function () {
        clearTimeout(timer_1);
      };
    }
  }, [dispatch, state]);
  var result = useMemo(function () {
    return {
      state: state,
      closeAll: handleCloseAll,
      close: handleClose,
      closed: handleClosed,
      open: handleOpen,
      engage: handleEngage,
      disengage: handleDisengage
    };
  }, [state, handleCloseAll, handleClose, handleClosed, handleOpen, handleEngage, handleDisengage]);
  return result;
}
/**
 * 오픈된 스낵바 아이템을 순회하여 스낵바를 노출할 위치를 리턴합니다.
 * fab가 하나라도 존재하면 fab로 리턴하고, 그렇지 않으면 basic을 리턴합니다.
 */
function getPlacement(items) {
  return items.some(function (item) {
    return item.options.placement === SNACKBAR_PLACEMENT.fab;
  }) ? SNACKBAR_PLACEMENT.fab : SNACKBAR_PLACEMENT.basic;
}

// TODO Button 을 Anchor로도 사용 가능한 형태로 개선 필요.
var BaseButton = /*#__PURE__*/forwardRef(function (_a, ref) {
  var children = _a.children,
    restProps = __rest(_a, ["children"]);
  return jsx(HoverInteraction, _assign({
    disabled: restProps.disabled
  }, {
    children: jsx(ResetButton, _assign({}, restProps, {
      ref: ref
    }, {
      children: children
    }))
  }));
});
var ResetButton = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e117vx0e0"
} : {
  target: "e117vx0e0",
  label: "ResetButton"
})(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  ", ";\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n"], ["\n  ", ";\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n"])), RESET_BUTTON);
var templateObject_1$9;

var iconSize = {
  14: 12,
  16: 16
};
var TextButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
    size = props.size,
    variant = props.variant,
    RightIcon = props.rightIcon,
    LeftIcon = props.leftIcon,
    className = props.className,
    restProps = __rest(props, ["children", "size", "variant", "rightIcon", "leftIcon", "className"]);
  return jsxs(TextButtonContainer, _assign({
    className: classNames([variant, "size-".concat(size), className])
  }, restProps, {
    ref: ref
  }, {
    children: [LeftIcon && jsx(LeftIcon, {
      "data-testid": "left-icon",
      className: "left-icon",
      size: iconSize[size]
    }), children, RightIcon && jsx(RightIcon, {
      "data-testid": "right-icon",
      className: "right-icon",
      size: iconSize[size]
    })]
  }));
});
var TextButtonContainer = /*#__PURE__*/_styled(BaseButton, process.env.NODE_ENV === "production" ? {
  target: "e1wbybap0"
} : {
  target: "e1wbybap0",
  label: "TextButtonContainer"
})(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  padding: ", " ", ";\n  border-radius: 4px;\n  \n  &.primary {\n    color: ", ";\n  }\n  &.neutral-500 {\n    color: ", ";\n  }\n  &.neutral-600 {\n    color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n  }\n  \n  &.size-14 {\n    ", ";\n  }\n  &.size-16 {\n    ", ";\n    font-weight: 500;\n  }\n  \n  .left-icon {\n    margin-right: ", ";\n  }\n  .right-icon {\n    margin-left: ", ";\n  }\n"], ["\n  padding: ", " ", ";\n  border-radius: 4px;\n  \n  &.primary {\n    color: ", ";\n  }\n  &.neutral-500 {\n    color: ", ";\n  }\n  &.neutral-600 {\n    color: ", ";\n  }\n  &:disabled {\n    color: ", ";\n  }\n  \n  &.size-14 {\n    ", ";\n  }\n  &.size-16 {\n    ", ";\n    font-weight: 500;\n  }\n  \n  .left-icon {\n    margin-right: ", ";\n  }\n  .right-icon {\n    margin-left: ", ";\n  }\n"])), pxToRem(4), pxToRem(8), function (_a) {
  var theme = _a.theme;
  return theme.primary.basic;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral500;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral600;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral400;
}, FONT_STYLE.body14L18, FONT_STYLE.body16L20, pxToRem(4), pxToRem(4));
var templateObject_1$8;

var fadeIn = keyframes(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var fadeOut = keyframes(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"], ["\n  0% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n"])));
function cssAnimation(isClosing) {
  if (!isClosing) return /*#__PURE__*/css(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["animation: ", " 0.3s 0.1s cubic-bezier(0.33, 1, 0.68, 1) both;" + (process.env.NODE_ENV === "production" ? "" : ";label:cssAnimation;")], ["animation: ", " 0.3s 0.1s cubic-bezier(0.33, 1, 0.68, 1) both;" + (process.env.NODE_ENV === "production" ? "" : ";label:cssAnimation;")])), fadeIn);
  return /*#__PURE__*/css(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["animation: ", " 0.2s cubic-bezier(0.215, 0.61, 0.355, 1)  forwards;" + (process.env.NODE_ENV === "production" ? "" : ";label:cssAnimation;")], ["animation: ", " 0.2s cubic-bezier(0.215, 0.61, 0.355, 1)  forwards;" + (process.env.NODE_ENV === "production" ? "" : ";label:cssAnimation;")])), fadeOut);
}
function SnackbarItem(_a) {
  var className = _a.className,
    PrefixIcon = _a.prefixIcon,
    content = _a.content,
    buttons = _a.buttons,
    onClick = _a.onClick,
    onCloseAnimationEnd = _a.onCloseAnimationEnd,
    isClosing = _a.isClosing,
    suffixButton = _a.suffixButton;
  return jsxs(SnackbarWrapper, _assign({
    "data-testid": "snackbar-item",
    className: className,
    css: [cssAnimation(isClosing)],
    onClick: onClick,
    onAnimationEnd: isClosing ? onCloseAnimationEnd : undefined
  }, {
    children: [!!PrefixIcon && jsx(PrefixIcon, {
      "data-testid": "snackbar-item-icon",
      className: "prefix-icon",
      size: 18
    }), jsx(Content, {
      children: content
    }), suffixButton && jsx(SnackbarButton, _assign({
      size: 14,
      variant: "primary",
      type: "button",
      onClick: suffixButton.onClick
    }, {
      children: suffixButton.title
    })), buttons && (buttons === null || buttons === void 0 ? void 0 : buttons.length) > 0 && jsx(ButtonWrapper$2, {
      children: buttons.map(function (buttonProps, i) {
        return /** FIXME TextButton 구현 후 적용 */(
          jsx(SnackbarButton, _assign({
            size: 14,
            variant: "primary",
            type: "button"
          }, buttonProps), i)
        );
      })
    })]
  }));
}
var SnackbarWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "efmkyib3"
} : {
  target: "efmkyib3",
  label: "SnackbarWrapper"
})(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  box-sizing: border-box;\n  display: flex;\n  padding: ", " ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  ", ";\n  color: ", ";\n\n  margin-top: ", ";\n  width: ", ";\n  ", "\n  ", "\n  \n  .prefix-icon {\n    margin-right: ", ";\n  }\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  padding: ", " ", ";\n  background-color: ", ";\n  border-radius: ", ";\n  ", ";\n  color: ", ";\n\n  margin-top: ", ";\n  width: ", ";\n  ", "\n  ", "\n  \n  .prefix-icon {\n    margin-right: ", ";\n  }\n"])), pxToRem(14), pxToRem(16), function (_a) {
  var theme = _a.theme;
  return theme.layer.dark;
}, pxToRem(4), FONT_STYLE.body14L18, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral0;
}, pxToRem(15), pxToRem(470), MEDIA_QUERY.max('tablet', /*#__PURE__*/css(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n    width: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:SnackbarWrapper;")], ["\n    width: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:SnackbarWrapper;")])), pxToRem(350))), MEDIA_QUERY.max('mobile', /*#__PURE__*/css(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n    width: 100%\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:SnackbarWrapper;")], ["\n    width: 100%\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:SnackbarWrapper;")])))), pxToRem(6));
var Content = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "efmkyib2"
} : {
  target: "efmkyib2",
  label: "Content"
})(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  flex: 1 1;\n  white-space: pre-line;\n  word-break: keep-all;\n  overflow-wrap: break-word;\n"], ["\n  flex: 1 1;\n  white-space: pre-line;\n  word-break: keep-all;\n  overflow-wrap: break-word;\n"])));
var ButtonWrapper$2 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "efmkyib1"
} : {
  target: "efmkyib1",
  label: "ButtonWrapper"
})(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin-left: ", ";\n"], ["\n  margin-left: ", ";\n"])), pxToRem(4));
var SnackbarButton = /*#__PURE__*/_styled(TextButton, process.env.NODE_ENV === "production" ? {
  target: "efmkyib0"
} : {
  target: "efmkyib0",
  label: "SnackbarButton"
})(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  padding: 0;\n  &:not(:first-of-type) {\n  margin-left: ", ";\n}"], ["\n  padding: 0;\n  &:not(:first-of-type) {\n  margin-left: ", ";\n}"])), pxToRem(8));
var templateObject_1$7, templateObject_2$7, templateObject_3$4, templateObject_4$3, templateObject_5$2, templateObject_6$2, templateObject_7$2, templateObject_8$1, templateObject_9, templateObject_10;

var convertBdsOptionAsOds = function convertBdsOptionAsOds(props) {
  var icon = props.icon,
    type = props.type,
    multiline = props.multiline,
    rest = __rest(props, ["icon", "type", "multiline"]);
  var newProps = rest;
  if (icon) {
    console.warn('Snackbar: icon is deprecated. Use prefixIcon instead.');
    newProps = _assign(_assign({}, newProps), {
      prefixIcon: InfoIcon
    });
  }
  if (type) {
    console.warn('Snackbar: type is deprecated. Only normal type design is allowed.');
  }
  // deprecated 되어야 할 대상이지만, 하위호환성을 위해 실제 구현 단에서는 활용하도록 남겨둡니다.
  if (rest.buttons) {
    console.warn('Snackbar: buttons is deprecated. Use button props instead.');
  }
  if (multiline) {
    console.warn('Snackbar: multiline is deprecated. Do not use multiline.');
  }
  return newProps;
};

var _a;
/** 스낵바 위치 */
var BOTTOM_SIZE = (_a = {}, _a[SNACKBAR_PLACEMENT.basic] = {
  mobile: 8,
  pc: 40
}, _a[SNACKBAR_PLACEMENT.fab] = {
  mobile: 70,
  pc: 40
}, _a);
function SnackbarList(props) {
  var _a = props.state,
    items = _a.items,
    placement = _a.placement,
    close = props.close,
    closed = props.closed,
    engage = props.engage,
    disengage = props.disengage;
  // TODO 사용되는 서비스들에서 마이그레이션 완료 후 제거
  var odsItems = useMemo(function () {
    return items.map(function (item) {
      return _assign(_assign({}, item), {
        options: convertBdsOptionAsOds(item.options)
      });
    });
  }, [items]);
  return jsx(BodyPortal, {
    children: jsx(Wrapper, _assign({
      "data-testid": "snackbar-list-wrapper"
    }, props, {
      onMouseEnter: engage,
      onMouseLeave: disengage,
      placement: placement
    }, {
      children: odsItems.map(function (_a, index) {
        var id = _a.id,
          state = _a.state,
          options = _a.options;
        return createElement(SnackbarItem, _assign({}, options, {
          key: id,
          isClosing: state === 'closing',
          onClick: function onClick() {
            var _a;
            (_a = options.onClick) === null || _a === void 0 ? void 0 : _a.call(options);
            close(id);
          },
          onCloseAnimationEnd: function onCloseAnimationEnd() {
            return closed(id);
          }
        }));
      })
    }))
  });
}
var Wrapper = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && !['open'].includes(prop);
  },
  target: "e1z07hv00"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return isPropValid(prop) && !['open'].includes(prop);
  },
  target: "e1z07hv00",
  label: "Wrapper"
})(function (_a) {
  var placement = _a.placement;
  return /*#__PURE__*/css(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n    position: fixed;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  bottom: ", ";\n  padding-inline: 8px;\n  z-index: ", ";\n  left: 0;\n  right: 0;\n  ", "\n" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")], ["\n    position: fixed;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  bottom: ", ";\n  padding-inline: 8px;\n  z-index: ", ";\n  left: 0;\n  right: 0;\n  ", "\n" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")])), pxToRem(BOTTOM_SIZE[placement].pc), ZINDEX.snackbar, MEDIA_QUERY.max('tablet', /*#__PURE__*/css(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n    bottom: ", ";\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")], ["\n    bottom: ", ";\n    ", "\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")])), pxToRem(BOTTOM_SIZE[placement].mobile), safeAreaInset('bottom', 'padding-bottom'))));
});
var templateObject_1$6, templateObject_2$6;

var SnackbarContext = /*#__PURE__*/createContext(null);
function SnackbarProvider(_a) {
  var children = _a.children;
  var state = useSnackbarState();
  return jsxs(SnackbarContext.Provider, _assign({
    value: state
  }, {
    children: [children, jsx(SnackbarList, _assign({}, state))]
  }));
}
function useSnackbar() {
  var result = useContext(SnackbarContext);
  if (result == null) {
    throw new Error('SnackbarContext is not mounted');
  }
  return result;
}

var IconButton = /*#__PURE__*/forwardRef(function (_a, ref) {
  var IconElement = _a.icon,
    value = _a.value,
    _b = _a.valueAlignment,
    valueAlignment = _b === void 0 ? 'horizontal' : _b,
    className = _a.className,
    isActive = _a.isActive,
    ActiveIcon = _a.activeIcon,
    _c = _a.hasBorder,
    hasBorder = _c === void 0 ? false : _c,
    rest = __rest(_a, ["icon", "value", "valueAlignment", "className", "isActive", "activeIcon", "hasBorder"]);
  return jsxs(Container$3, _assign({
    ref: ref
  }, rest, {
    className: classNames(className, {
      horizontal: valueAlignment === 'horizontal',
      vertical: valueAlignment === 'vertical'
    }),
    type: "button"
  }, {
    children: [jsx(IconWrapper, _assign({
      className: classNames({
        border: hasBorder
      }),
      "data-testid": "icon-wrapper"
    }, {
      children: ActiveIcon && isActive ? jsx(ActiveIcon, {
        size: 24,
        "data-testid": "active-icon",
        fill: function fill(theme) {
          return theme.primary.basic;
        }
      }) : jsx(IconElement, {
        size: 24,
        "data-testid": "inactive-icon",
        fill: function fill(theme) {
          return theme.base.neutral700;
        }
      })
    })), value && jsx(ValueText, {
      children: formatComma(value)
    })]
  }));
});
var Container$3 = /*#__PURE__*/_styled("button", process.env.NODE_ENV === "production" ? {
  target: "e2itrfe2"
} : {
  target: "e2itrfe2",
  label: "Container"
})(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  background: none;\n  border: none;\n  color: ", ";\n  font-family: inherit;\n  padding: 0;\n  margin: 0;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n\n  &.vertical {\n    flex-direction: column;\n  }\n\n  &.horizontal {\n    flex-direction: row;\n  }\n"], ["\n  background: none;\n  border: none;\n  color: ", ";\n  font-family: inherit;\n  padding: 0;\n  margin: 0;\n\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n\n  &.vertical {\n    flex-direction: column;\n  }\n\n  &.horizontal {\n    flex-direction: row;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.base.neutral700;
});
var IconWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e2itrfe1"
} : {
  target: "e2itrfe1",
  label: "IconWrapper"
})(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n  &.border {\n    padding: 10px;\n    border: 1px solid ", ";\n    border-radius: 50%;\n  }\n\n  > svg {\n    vertical-align: middle;\n  }\n"], ["\n  &.border {\n    padding: 10px;\n    border: 1px solid ", ";\n    border-radius: 50%;\n  }\n\n  > svg {\n    vertical-align: middle;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.border;
});
var ValueText = /*#__PURE__*/_styled("p", process.env.NODE_ENV === "production" ? {
  target: "e2itrfe0"
} : {
  target: "e2itrfe0",
  label: "ValueText"
})(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), FONT_STYLE.detail12L16);
var templateObject_1$5, templateObject_2$5, templateObject_3$3;

var boxButtonColorLookup = function boxButtonColorLookup(theme) {
  return {
    filled: {
      'primary': {
        backgroundColor: theme.primary.basic,
        disabledBorderColor: theme.disabled.filled1,
        borderColor: theme.primary.basic,
        textColor: theme.base.neutral0,
        disabledBackgroundColor: theme.disabled.filled1,
        disabledTextColor: theme.base.neutral400
      },
      'neutral-600': {
        backgroundColor: '',
        disabledBorderColor: '',
        borderColor: '',
        textColor: '',
        disabledBackgroundColor: '',
        disabledTextColor: ''
      }
    },
    outlined: {
      'primary': {
        borderColor: theme.primary.basic,
        textColor: theme.primary.basic,
        disabledBorderColor: theme.border,
        disabledTextColor: theme.base.neutral400,
        backgroundColor: 'inherit',
        disabledBackgroundColor: 'inherit'
      },
      'neutral-600': {
        borderColor: theme.border,
        textColor: theme.base.neutral600,
        disabledBorderColor: theme.border,
        disabledTextColor: theme.base.neutral400,
        backgroundColor: 'inherit',
        disabledBackgroundColor: 'inherit'
      }
    }
  };
};
var boxButtonSizeLookup = {
  28: {
    paddingInline: 8,
    paddingBlock: 4,
    fontWeight: 500,
    fontSize: FONT_STYLE.body14L20
  },
  32: {
    paddingInline: 8,
    paddingBlock: 6,
    fontWeight: 600,
    fontSize: FONT_STYLE.body14L20
  },
  40: {
    paddingInline: 16,
    paddingBlock: 10,
    fontWeight: 600,
    fontSize: FONT_STYLE.body14L20
  },
  44: {
    paddingInline: 16,
    paddingBlock: 12,
    fontWeight: 700,
    fontSize: FONT_STYLE.body16L20
  },
  50: {
    paddingInline: 16,
    paddingBlock: 15,
    fontWeight: 700,
    fontSize: FONT_STYLE.body16L20
  }
};
/**
 * 버튼의 타입에 따른 style을 반환합니다.
 * @param variant
 * @param shape
 * @param theme
 */
var getBoxButtonVariantStyle = function getBoxButtonVariantStyle(_a) {
  var variant = _a.variant,
    shape = _a.shape,
    theme = _a.theme;
  var colors = boxButtonColorLookup(theme)[shape][variant];
  return /*#__PURE__*/css(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    border: 1px solid ", ";\n    &:disabled {\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:getBoxButtonVariantStyle;")], ["\n    color: ", ";\n    background-color: ", ";\n    border: 1px solid ", ";\n    &:disabled {\n      background-color: ", ";\n      color: ", ";\n      border-color: ", ";\n    }\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:getBoxButtonVariantStyle;")])), colors.textColor, colors.backgroundColor, colors.borderColor, colors.disabledBackgroundColor, colors.disabledTextColor, colors.disabledBorderColor);
};
/**
 * BoxButton의 size에 따른 style을 반환합니다.
 * @param size
 */
var getButtonSizeStyle = function getButtonSizeStyle(size) {
  var _a = boxButtonSizeLookup[size],
    fontSize = _a.fontSize,
    fontWeight = _a.fontWeight,
    paddingBlock = _a.paddingBlock,
    paddingInline = _a.paddingInline;
  return /*#__PURE__*/css(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n    ", ";\n    font-weight: ", ";\n    padding: ", " ", ";\n    height: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:getButtonSizeStyle;")], ["\n    ", ";\n    font-weight: ", ";\n    padding: ", " ", ";\n    height: ", ";\n  " + (process.env.NODE_ENV === "production" ? "" : ";label:getButtonSizeStyle;")])), fontSize, fontWeight, pxToRem(paddingBlock), pxToRem(paddingInline), pxToRem(size));
};
/**
 * BoxButton내 아이콘의 사이즈를 button size에 알맞은 값으로 반환합니다.
 * @param buttonSize
 */
var getBoxButtonIconSize = function getBoxButtonIconSize(buttonSize) {
  switch (buttonSize) {
    case 28:
    case 32:
    case 40:
      return 16;
    case 44:
    case 50:
      return 18;
    default:
      throw new Error('Invalid button size');
  }
};
/**
 * BoxButton의 variant에 대응하는 loading variant를 반환합니다.
 * @param variant
 * @param shape
 */
var getBoxButtonLoadingVariant = function getBoxButtonLoadingVariant(_a) {
  var variant = _a.variant,
    shape = _a.shape;
  switch (shape) {
    case 'filled':
      switch (variant) {
        case 'primary':
          return 'white';
        case 'neutral-600':
          return 'base1';
      }
      break;
    case 'outlined':
      switch (variant) {
        case 'primary':
          return 'primary1';
        case 'neutral-600':
          return 'base1';
      }
      break;
  }
};
var templateObject_1$4, templateObject_2$4;

var BoxButton = /*#__PURE__*/forwardRef(function (props, ref) {
  var theme = useTheme();
  var children = props.children,
    LeftIcon = props.leftIcon,
    RightIcon = props.rightIcon,
    shape = props.shape,
    variant = props.variant,
    size = props.size,
    width = props.width,
    isLoading = props.isLoading,
    className = props.className,
    restProps = __rest(props, ["children", "leftIcon", "rightIcon", "shape", "variant", "size", "width", "isLoading", "className"]);
  return jsxs(BoxButtonContainer, _assign({
    ref: ref,
    css: [getBoxButtonVariantStyle({
      variant: variant,
      shape: shape,
      theme: theme
    }), getButtonSizeStyle(size), width && /*#__PURE__*/css({
      width: width
    }, process.env.NODE_ENV === "production" ? "" : ";label:css;")],
    className: classNames(className, {
      loading: isLoading
    })
  }, restProps, {
    children: [LeftIcon && jsx(LeftIcon, {
      "data-testid": "left-icon",
      className: "left-icon",
      size: getBoxButtonIconSize(size)
    }), children, RightIcon && jsx(RightIcon, {
      "data-testid": "right-icon",
      className: "right-icon",
      size: getBoxButtonIconSize(size)
    }), !restProps.disabled && isLoading && jsx(LoadingContainer, {
      children: jsx(Loading, {
        "data-testid": "button-loading",
        variant: getBoxButtonLoadingVariant({
          variant: variant,
          shape: shape
        })
      })
    })]
  }));
});
var BoxButtonContainer = /*#__PURE__*/_styled(BaseButton, process.env.NODE_ENV === "production" ? {
  target: "e5j3oup1"
} : {
  target: "e5j3oup1",
  label: "BoxButtonContainer"
})(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  border-radius: ", ";\n  &.loading {\n    pointer-events: none;\n    cursor: default;\n    color: transparent;\n  }\n  \n  .left-icon {\n    margin-right: ", ";\n  }\n  .right-icon {\n    margin-left: ", ";\n  }\n"], ["\n  border-radius: ", ";\n  &.loading {\n    pointer-events: none;\n    cursor: default;\n    color: transparent;\n  }\n  \n  .left-icon {\n    margin-right: ", ";\n  }\n  .right-icon {\n    margin-left: ", ";\n  }\n"])), pxToRem(4), pxToRem(4), pxToRem(4));
var LoadingContainer = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e5j3oup0"
} : {
  target: "e5j3oup0",
  label: "LoadingContainer"
})(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n"], ["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n"])));
var templateObject_1$3, templateObject_2$3;

var CautionBox = /*#__PURE__*/forwardRef(function (props, ref) {
  var title = props.title,
    description = props.description,
    className = props.className,
    buttonText = props.buttonText,
    onButtonClick = props.onButtonClick,
    rest = __rest(props, ["title", "description", "className", "buttonText", "onButtonClick"]);
  return jsxs(Container$2, _assign({
    ref: ref
  }, rest, {
    className: className
  }, {
    children: [jsxs(Header, {
      children: [jsx(StyledAlertFilledIcon, {
        size: 18,
        fill: function fill(theme) {
          return theme.accent.darken;
        }
      }), jsx(TopText, {
        children: title ? jsx(Title$2, {
          children: title
        }) : jsx(Description$1, _assign({
          as: "span"
        }, {
          children: description
        }))
      })]
    }), title && description && jsx(Description$1, {
      children: description
    }), buttonText && jsx(ButtonWrapper$1, _assign({
      variant: "neutral-600",
      shape: "outlined",
      size: 40,
      onClick: onButtonClick
    }, {
      children: buttonText
    }))]
  }));
});
var Container$2 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q6"
} : {
  target: "e1x05w0q6",
  label: "Container"
})(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  padding: 12px 16px;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  background-color: ", ";\n"], ["\n  padding: 12px 16px;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  background-color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.base.neutral200;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral100;
});
var Header = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q5"
} : {
  target: "e1x05w0q5",
  label: "Header"
})(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n"], ["\n"])));
var StyledAlertFilledIcon = /*#__PURE__*/_styled(AlertFilledIcon, process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q4"
} : {
  target: "e1x05w0q4",
  label: "StyledAlertFilledIcon"
})(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  margin-right: 6px;\n  vertical-align: middle;\n"], ["\n  margin-right: 6px;\n  vertical-align: middle;\n"])));
var TopText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q3"
} : {
  target: "e1x05w0q3",
  label: "TopText"
})(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.base.neutral600;
});
var Title$2 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q2"
} : {
  target: "e1x05w0q2",
  label: "Title"
})(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n  ", ";\n  vertical-align: middle;\n  font-weight: 700;\n"], ["\n  ", ";\n  vertical-align: middle;\n  font-weight: 700;\n"])), FONT_STYLE.body16L24);
var Description$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q1"
} : {
  target: "e1x05w0q1",
  label: "Description"
})(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  ", ";\n  font-weight: 400;\n  margin-top: 4px;\n"], ["\n  ", ";\n  font-weight: 400;\n  margin-top: 4px;\n"])), FONT_STYLE.body15L24);
var ButtonWrapper$1 = /*#__PURE__*/_styled(BoxButton, process.env.NODE_ENV === "production" ? {
  target: "e1x05w0q0"
} : {
  target: "e1x05w0q0",
  label: "ButtonWrapper"
})(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  width: 100%;\n  margin-top: 8px;\n"], ["\n  width: 100%;\n  margin-top: 8px;\n"])));
var templateObject_1$2, templateObject_2$2, templateObject_3$2, templateObject_4$2, templateObject_5$1, templateObject_6$1, templateObject_7$1;

var Input = /*#__PURE__*/forwardRef(function (props, ref) {
  var size = props.size,
    width = props.width,
    title = props.title,
    placeholder = props.placeholder,
    icon = props.icon,
    textButton = props.textButton,
    hint = props.hint,
    _a = props.error,
    error = _a === void 0 ? false : _a,
    _b = props.disabled,
    disabled = _b === void 0 ? false : _b,
    count = props.count,
    _c = props.value,
    value = _c === void 0 ? '' : _c,
    _onFocus = props.onFocus,
    _onBlur = props.onBlur,
    className = props.className,
    rest = __rest(props, ["size", "width", "title", "placeholder", "icon", "textButton", "hint", "error", "disabled", "count", "value", "onFocus", "onBlur", "className"]);
  var _d = useState(false),
    focused = _d[0],
    setFocused = _d[1];
  var _e = icon || {},
    IconComponent = _e.iconComponent,
    onIconClick = _e.onClick;
  var _f = textButton || {},
    text = _f.text,
    onTextButtonClick = _f.onClick;
  var _g = count || {},
    showCount = _g.showCount,
    max = _g.max;
  var isError = error || showCount && "".concat(value).length > max;
  return jsxs(Container$1, _assign({
    className: className,
    css: [width && /*#__PURE__*/css({
      width: width
    }, process.env.NODE_ENV === "production" ? "" : ";label:css;")],
    "data-testid": "input-container"
  }, {
    children: [title && jsx(Title$1, {
      children: title
    }), jsxs(InputWrapper, _assign({
      className: classNames('input-wrapper', {
        focused: focused,
        error: isError,
        disabled: disabled
      }),
      "data-testid": "input-wrapper"
    }, {
      children: [jsx(StyledInput, _assign({
        ref: ref,
        size: size,
        "data-testid": "input"
      }, rest, {
        value: value,
        disabled: disabled,
        placeholder: placeholder,
        onFocus: function onFocus(e) {
          if (_onFocus) {
            _onFocus(e);
          }
          setFocused(true);
        },
        onBlur: function onBlur(e) {
          if (_onBlur) {
            _onBlur(e);
          }
          setFocused(false);
        }
      })), IconComponent && jsx(IconComponent, {
        size: 18,
        className: classNames('input-icon'),
        "data-testid": "input-icon",
        fill: function fill(theme) {
          return theme.base.neutral500;
        },
        onClick: onIconClick,
        style: {
          verticalAlign: 'middle',
          margin: "auto ".concat(text ? '0' : '6px', " auto auto"),
          cursor: 'pointer'
        }
      }), text && jsx(TextButton, _assign({
        size: 14,
        className: classNames('input-text-button'),
        "data-testid": "input-text-button",
        variant: "primary",
        onClick: onTextButtonClick,
        disabled: value === '' || disabled,
        style: {
          verticalAlign: 'middle',
          margin: 'auto 4px auto auto',
          width: 'max-content'
        }
      }, {
        children: text
      }))]
    })), jsxs(StyledHelper, {
      children: [hint && jsx(StyledHint, _assign({
        className: classNames('input-hint', {
          error: isError
        })
      }, {
        children: hint
      })), showCount && jsxs(StyledHint, _assign({
        className: classNames('input-count', {
          error: isError
        }),
        style: {
          textAlign: 'right'
        }
      }, {
        children: ["".concat(value).length, "/", max]
      }))]
    })]
  }));
});
var Container$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eagkmyb5"
} : {
  target: "eagkmyb5",
  label: "Container"
})(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  user-select: none;\n  display: inline-block;\n"], ["\n  user-select: none;\n  display: inline-block;\n"])));
var Title$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eagkmyb4"
} : {
  target: "eagkmyb4",
  label: "Title"
})(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  ", ";\n  margin-bottom: 4px;\n  color: ", ";\n"], ["\n  ", ";\n  margin-bottom: 4px;\n  color: ", ";\n"])), FONT_STYLE.body14L18, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral500;
});
var InputWrapper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eagkmyb3"
} : {
  target: "eagkmyb3",
  label: "InputWrapper"
})(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  border-radius: 4px;\n  display: flex;\n  width: 100%;\n\n  &.focused {\n    border-color: ", ";\n  }\n\n  &.error {\n    border-color: ", ";\n  }\n\n  &.disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"], ["\n  border: 1px solid ", ";\n  border-radius: 4px;\n  display: flex;\n  width: 100%;\n\n  &.focused {\n    border-color: ", ";\n  }\n\n  &.error {\n    border-color: ", ";\n  }\n\n  &.disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.border;
}, function (_a) {
  var theme = _a.theme;
  return theme.primary.basic;
}, function (_a) {
  var theme = _a.theme;
  return theme.accent.basic;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral300;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral100;
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral400;
});
var StyledInput = /*#__PURE__*/_styled("input", process.env.NODE_ENV === "production" ? {
  target: "eagkmyb2"
} : {
  target: "eagkmyb2",
  label: "StyledInput"
})(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", ";\n  box-sizing: border-box;\n  color: ", ";\n  min-width: 0;\n  flex: 1 1;\n\n  ", "\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  :focus {\n    outline: none;\n  }\n"], ["\n  ", ";\n  box-sizing: border-box;\n  color: ", ";\n  min-width: 0;\n  flex: 1 1;\n\n  ", "\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  :focus {\n    outline: none;\n  }\n"])), RESET_INPUT, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral700;
}, function (_a) {
  var size = _a.size;
  switch (size) {
    case 32:
      return /*#__PURE__*/css(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n          ", ";\n          height: 32px;\n          padding: 6px 12px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledInput;")], ["\n          ", ";\n          height: 32px;\n          padding: 6px 12px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledInput;")])), FONT_STYLE.body14L20);
    case 40:
      return /*#__PURE__*/css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n          ", ";\n          height: 40px;\n          padding: 8px 12px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledInput;")], ["\n          ", ";\n          height: 40px;\n          padding: 8px 12px;\n        " + (process.env.NODE_ENV === "production" ? "" : ";label:StyledInput;")])), FONT_STYLE.body16L24);
  }
}, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral400;
});
var StyledHelper = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eagkmyb1"
} : {
  target: "eagkmyb1",
  label: "StyledHelper"
})(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var StyledHint = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "eagkmyb0"
} : {
  target: "eagkmyb0",
  label: "StyledHint"
})(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", ";\n  color: ", ";\n  margin-top: 4px;\n  flex-grow: 1;\n\n  &.error {\n    color: ", ";\n  }\n"], ["\n  ", ";\n  color: ", ";\n  margin-top: 4px;\n  flex-grow: 1;\n\n  &.error {\n    color: ", ";\n  }\n"])), FONT_STYLE.detail12L16, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral500;
}, function (_a) {
  var theme = _a.theme;
  return theme.accent.basic;
});
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4$1, templateObject_5, templateObject_6, templateObject_7, templateObject_8;

var Empty = /*#__PURE__*/forwardRef(function (props, ref) {
  var title = props.title,
    description = props.description,
    className = props.className,
    buttonText = props.buttonText,
    onButtonClick = props.onButtonClick,
    rest = __rest(props, ["title", "description", "className", "buttonText", "onButtonClick"]);
  return jsxs(Container, _assign({
    ref: ref
  }, rest, {
    className: className
  }, {
    children: [title && jsx(Title, {
      children: title
    }), description && jsx(Description, {
      children: description
    }), buttonText && jsx(ButtonWrapper, _assign({
      variant: "primary",
      shape: "filled",
      size: 44,
      onClick: onButtonClick
    }, {
      children: buttonText
    }))]
  }));
});
var Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ijkmt13"
} : {
  target: "e1ijkmt13",
  label: "Container"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 12px 16px;\n  text-align: center;\n"], ["\n  padding: 12px 16px;\n  text-align: center;\n"])));
var Title = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ijkmt12"
} : {
  target: "e1ijkmt12",
  label: "Title"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  font-weight: 600;\n  vertical-align: middle;\n  color: ", ";\n"], ["\n  ", ";\n  font-weight: 600;\n  vertical-align: middle;\n  color: ", ";\n"])), FONT_STYLE.heading20, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral700;
});
var Description = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1ijkmt11"
} : {
  target: "e1ijkmt11",
  label: "Description"
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  vertical-align: middle;\n  color: ", ";\n"], ["\n  ", ";\n  vertical-align: middle;\n  color: ", ";\n"])), FONT_STYLE.body16L24, function (_a) {
  var theme = _a.theme;
  return theme.base.neutral500;
});
var ButtonWrapper = /*#__PURE__*/_styled(BoxButton, process.env.NODE_ENV === "production" ? {
  target: "e1ijkmt10"
} : {
  target: "e1ijkmt10",
  label: "ButtonWrapper"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  margin-top: 8px;\n"], ["\n  margin-top: 8px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

function DesignSystemProvider(_a) {
  var mode = _a.mode,
    children = _a.children;
  var theme = mode === 'dark' ? DARK_THEME : LIGHT_THEME;
  return jsx(ThemeProvider, _assign({
    theme: theme
  }, {
    children: jsx(SnackbarProvider, {
      children: jsx(StickyProvider, {
        children: jsx(OverlayProvider, {
          children: children
        })
      })
    })
  }));
}
/**
 * @deprecated DesignSystemProvider 컴포넌트를 사용해 주세요.
 */
var BdsProvider = DesignSystemProvider;

export { AlertFilledIcon, Avatar, BdsProvider, BoxButton, CautionBox, Chip, CircleBadge, DARK_THEME, DesignSystemProvider, Divider, DotBadge, Empty, FONT_STYLE, HoverInteraction, IconButton, IndicatorDots, InfoIcon, Input, LIGHT_THEME, MEDIA_QUERY, OverlayProvider, PillBadge, RESET_BUTTON, RESET_INPUT, ResizeImage, SNACKBAR_PLACEMENT, SnackbarContext, SnackbarProvider, SquareBadge, TextButton, ZINDEX, dotSize, pxToRem, safeAreaInset, useSnackbar };
//# sourceMappingURL=index.js.map
